document.addEventListener('DOMContentLoaded', function () {

  // Initialize every product section on the page independently.
  // Using querySelector (singular) here was the bug: if more than one
  // [data-product-section] element exists on the page, only the first
  // one ever got its buttons wired up, leaving every other instance's
  // size/quantity/tab buttons doing nothing.
  document.querySelectorAll('[data-product-section]').forEach(initProductSection);

  function initProductSection(section) {
    const productId = section.dataset.productId;

    /* ===== GALLERY ===== */
    const mainImage = section.querySelector('#tpd-main-image');
    const thumbnails = section.querySelectorAll('.tpd-thumbnail');
    const prevButton = section.querySelector('.tpd-arrow-prev');
    const nextButton = section.querySelector('.tpd-arrow-next');
    let currentIndex = 0;

    function updateImage(index) {
      if (!thumbnails.length || !mainImage) return;
      currentIndex = index;
      const selected = thumbnails[currentIndex];
      mainImage.src = selected.dataset.imageUrl;
      thumbnails.forEach(function (t) { t.classList.remove('active'); });
      selected.classList.add('active');
    }

    thumbnails.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { updateImage(index); });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        currentIndex = currentIndex <= 0 ? thumbnails.length - 1 : currentIndex - 1;
        updateImage(currentIndex);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        currentIndex = currentIndex >= thumbnails.length - 1 ? 0 : currentIndex + 1;
        updateImage(currentIndex);
      });
    }

    /* ===== QUANTITY SELECTOR ===== */
    const qtyInput = section.querySelector('#tpd-quantity');
    const qtyDecrease = section.querySelector('.tpd-qty-decrease');
    const qtyIncrease = section.querySelector('.tpd-qty-increase');

    if (qtyDecrease && qtyInput) {
      qtyDecrease.addEventListener('click', function () {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, current - 1);
      });
    }

    if (qtyIncrease && qtyInput) {
      qtyIncrease.addEventListener('click', function () {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
      });
    }

    /* ===== VARIANT PICKER ===== */
    const dataScript = document.getElementById('tpd-product-json-' + productId);

    if (dataScript) {
      try {
        const productData = JSON.parse(dataScript.textContent);
        const variants = productData.variants;
        const optionGroups = section.querySelectorAll('.tpd-option-group');
        const variantIdInput = section.querySelector('#tpd-variant-id');
        const priceWrapper = section.querySelector('#tpd-price');
        const addToCartButton = section.querySelector('#tpd-add-to-cart');
        const stockLabel = section.querySelector('.tpd-stock-left');

        function formatMoney(cents) {
          return '₹' + (cents / 100).toFixed(2);
        }

        function getSelectedOptions() {
          const selected = [];
          optionGroups.forEach(function (group) {
            const active = group.querySelector('.tpd-option-value.selected');
            selected.push(active ? active.dataset.optionValue : null);
          });
          return selected;
        }

        function findMatchingVariant(selectedOptions) {
          return variants.find(function (variant) {
            const variantOptions = [variant.option1, variant.option2, variant.option3];
            return selectedOptions.every(function (value, i) {
              return value === null || variantOptions[i] === value;
            });
          });
        }

        function updateAvailability(selectedOptions) {
          optionGroups.forEach(function (group, groupIndex) {
            const buttons = group.querySelectorAll('.tpd-option-value');
            buttons.forEach(function (button) {
              const test = selectedOptions.slice();
              test[groupIndex] = button.dataset.optionValue;
              const match = findMatchingVariant(test);
              if (match && !match.available) {
                button.classList.add('unavailable');
              } else {
                button.classList.remove('unavailable');
              }
            });
          });
        }

        function updateUI(variant) {
          if (!variant) return;

          if (variantIdInput) variantIdInput.value = variant.id;

          if (priceWrapper) {
            const compareAt = variant.compare_at_price;
            const price = variant.price;
            let html = '';
            if (compareAt && compareAt > price) {
              html += '<span class="tpd-sale-price">' + formatMoney(price) + '</span>';
              html += '<span class="tpd-compare-price">' + formatMoney(compareAt) + '</span>';
            } else {
              html += '<span class="tpd-sale-price">' + formatMoney(price) + '</span>';
            }
            priceWrapper.innerHTML = html;
          }

          if (addToCartButton) {
            addToCartButton.disabled = !variant.available;
            if (variant.available) {
              addToCartButton.innerHTML = 'Add to cart · <span id="tpd-cart-btn-price">' + formatMoney(variant.price) + '</span>';
            } else {
              addToCartButton.textContent = 'Sold out';
            }
          }

          if (stockLabel) {
            if (variant.inventory_management && variant.inventory_quantity <= 10 && variant.inventory_quantity > 0) {
              stockLabel.style.display = '';
              stockLabel.textContent = 'left ' + variant.inventory_quantity + ' in stock';
            } else {
              stockLabel.style.display = 'none';
            }
          }

          if (mainImage && variant.featured_image) {
            mainImage.src = variant.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_1200x$1$2');
          }
        }

        optionGroups.forEach(function (group) {
          const labelValueEl = group.querySelector('.tpd-option-selected');
          const buttons = group.querySelectorAll('.tpd-option-value');

          buttons.forEach(function (button) {
            button.addEventListener('click', function () {
              if (button.classList.contains('unavailable')) return;

              buttons.forEach(function (sib) { sib.classList.remove('selected'); });
              button.classList.add('selected');

              if (labelValueEl) labelValueEl.textContent = button.dataset.optionValue;

              const selectedOptions = getSelectedOptions();
              const matched = findMatchingVariant(selectedOptions);

              updateAvailability(selectedOptions);

              if (matched) updateUI(matched);
            });
          });
        });

        updateAvailability(getSelectedOptions());
      } catch (err) {
        console.error('Variant picker failed to initialize:', err);
      }
    }

    /* ===== TABS ===== */
    const tabButtons = section.querySelectorAll('.tpd-tab-btn');
    const tabPanels = section.querySelectorAll('.tpd-tab-panel');

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const target = button.dataset.tab;

        tabButtons.forEach(function (b) { b.classList.remove('active'); });
        tabPanels.forEach(function (p) { p.classList.remove('active'); });

        button.classList.add('active');
        const panel = section.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

});